import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthService from 'services/AuthService';

type Props = RouteProps & { adminAllowed?: boolean };

const SystemAdminRoute: React.FunctionComponent<Props> = ({ component: Component, adminAllowed, ...rest }) => {
  if (!AuthService.isAuthenticated()) {
    window.sessionStorage.setItem('redirectUrl', window.location.pathname);
    return <Route {...rest} render={() => <Redirect to={EpdRoutes.login} />} />;
  }

  const hasAccess = adminAllowed ? AuthService.isAdmin() || AuthService.isSystemAdmin() : AuthService.isSystemAdmin();

  if (!hasAccess) {
    return <Route {...rest} render={() => <Redirect to={EpdRoutes.forbidden} />} />;
  }

  return <Route {...rest} component={Component} />;
};

export default SystemAdminRoute;
